import Users from '../views/Users'
import UsersIndex from '../views/users/Index'
import UsersCreate from '../views/users/Create'
import UsersView from '../views/users/View'

export const CLIENTS_ROUTES = {
  path: '/clients',
  component: Users,
  meta: { title: 'Clients' },
  children: [
    {
      path: '',
      name: 'clients',
      component: UsersIndex,
      meta: { title: 'Clients' }
    },
    {
      path: 'new',
      name: 'clients-create',
      component: UsersCreate,
      meta: { title: 'Add New Client' }
    },
    {
      path: ':user_id',
      name: 'clients-view',
      component: UsersView,
      meta: { 
        title: 'Client Profile' 
      }
    }
  ]
};
